/*
 * @Author: mercer
 * @Email: 13928932429@163.com
 * @Date: 2020-04-01 21:05:45
 * @LastEditTime: 2020-04-01 21:07:57
 * @Description: 
 */
import axios from 'axios'
import router from '../router/index'


var baseUrl = "";
if(process.env.NODE_ENV=="production" && process.env.type =="test"){
  baseUrl = "//a2.v2go.fun";  
  // baseUrl = "//ccb.v2go.fun:80";
  // baseUrl = "//ygy.v2go.fun:80";
  // baseUrl = '//www.yangguangyao.com:8080'

}
else if(process.env.NODE_ENV=="production" && process.env.type =="prod"){
  baseUrl = "//api.yizhulife.com";
}
else{
  // baseUrl = "//a1.v2go.fun";
  baseUrl = '//a2.v2go.fun';
  // baseUrl = "//ccb.v2go.fun";
  // baseUrl = "//ygy.v2go.fun:80";
  // baseUrl = "//www.yangguangyao.com:8080"
}


var instance = axios.create({
  baseURL: baseUrl,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  var token = localStorage.getItem("token");
  // console.log("req token:"+token);
  // store.commit('setLoading',true)
  config.headers["TOKEN"] = token;
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
  // Do something with response data
  // store.commit('setLoading',false);
  if(response && response.headers){
    var token = response.headers["token"];
    if(token && token!="undefined"){
      localStorage.setItem("token",response.headers["token"])
    }

  }
  return response;
}, function (error) {
  // Do something with response error
  if (error.response.status == 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("userid");
    router.replace("login");
    //Toast('请求未经授权')
  }else if(error.response.status == 403){
    localStorage.removeItem("token");
    localStorage.removeItem("userid");
    router.replace("login");
    // Toast('请求未经授权')
  }
  return Promise.reject(error);
});

export default instance;



// WEBPACK FOOTER //
// ./src/api/axios.js